import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { type ListTip } from '@itinerary/ItineraryModuleTypes';
import TripPackageSet from '@itinerary/trip/TripPackageSet';
import { TrainPackageLoader } from '@itinerary/trip/train/TrainPackageLoader';
import { type TrainPackageLoaderConfig } from '@itinerary/trip/train/types';
import type TrainPackage from '@itinerary/trip/train/TrainPackage';
import {
    type TrainFilterData,
    type TrainFilters,
} from '@itinerary/trip/train/TrainModuleTypes';
import { type GetAvailableStatus } from '@clients/TrainApi';
import { SellTypeCode } from '@utils/train';
import Train from '@files/tips/Train.svg?component';

export default class TrainPackageSet extends TripPackageSet<
    TrainFilterData,
    TrainFilters,
    TrainPackage
> {
    override loader: TrainPackageLoader;

    override get listTips(): ListTip[] {
        return [
            {
                title: 'زمان به‌روزرسانی موجودی بلیط‌ها',
                description: `ظرفیت بلیط‌های کنسل شده هر روز به لیست فروش اضافه می‌شوند و امکان خرید آن‌ها برای شما فراهم می‌شود.`,
                iconImg: markRaw(Train),
                additionalInfo: {
                    label: 'ساعات به‌روزرسانی:',
                    content: '۱۹ ،۱۷ ،۱۵ ،۱۲ ،۹',
                    icon: faClock,
                },
                order: 1,
            },
        ];
    }

    protected override reset(
        config: TrainPackageLoaderConfig,
        filters: Record<TrainFilters, any>
    ) {
        super.reset(config, filters);
        this.loader = new TrainPackageLoader(config);
    }

    get adultCount() {
        return this.loader.adultCount;
    }

    get childCount() {
        return this.loader.childCount;
    }

    get infantCount() {
        return this.loader.infantCount;
    }

    get availableStatus() {
        return this.loader.availableStatus;
    }

    set availableStatus(status: GetAvailableStatus) {
        this.loader.availableStatus = status;
    }

    get selectedCapacityId() {
        return this.loader.selectedCapacityId;
    }

    set selectedCapacityId(capacityId: number | undefined) {
        this.loader.selectedCapacityId = capacityId;
    }

    override get isRouteEnabled(): boolean {
        if (this.loader._sellType === SellTypeCode.Car) {
            return false;
        }
        return super.isRouteEnabled;
    }

    constructor(
        config: TrainPackageLoaderConfig,
        /**
         * Contains filters that must be applied to the results
         */
        public override filters: Record<TrainFilters, any>
    ) {
        super(filters);
        this.loader = new TrainPackageLoader(config);
    }
}
